import { component } from 'picoapp'

export default component(({ node, state, actions }) => {
  // const toggle = document.querySelector('.js-toggle-grid')
  // toggle.addEventListener('click', () => {
  //   const homeGrid = document.querySelector('.js-home-grid')
  //   toggle.classList.toggle('open')
  //   homeGrid.classList.toggle('block')
  // })
  const logo = node.querySelector('.js-logo')
  logo.addEventListener('click', () => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0)
    }
  })
  const toggle = document.querySelector('.js-toggle-nav')
  toggle.addEventListener('click', () => {
    node.classList.toggle('nav-open')
  })

  const work = document.querySelector('.js-work')
  const nested = document.querySelector('.js-nested')
  work.addEventListener('click', e => {
    e.preventDefault()
    nested.classList.toggle('open')
  })

  const links = document.querySelectorAll('.js-link')
  links.forEach(link => {
    link.addEventListener('click', () => {

      node.classList.remove('nav-open')
      nested.classList.remove('open')
    })
  })
  return {
    onStateChange (state) {
      console.log('state changes', state)
    }
  }
})
